import React, {Component} from 'react';
import {Container, Row, Col} from "react-grid-system";
import _ from 'underscore';
import Group from "./MaintenantCardsV2/Group";
import GroupFilter from "./MaintenantCardsV2/GroupFilter";
import Record from "./MaintenantCardsV2/Record";
import {HashRouter as Router, Route, Link, Redirect} from 'react-router-dom'

class MaintenantCardsV2 extends Component {

    state = {
        groups: [],
        active: null
    };

    constructor(props) {
        super(props);

        this.records = [];
    }

    componentDidMount() {
        const groupColumn = this.props.voting.configurations.group.split("#");
        const sortColumn = this.props.voting.configurations.sort;
        const groups = {};

        this.props.voting.data.forEach(data => {
            this.records[data.id] = data;
            let disable = data.fields['Lieu'] ? false : true;
            _.each(data.fields['Lieu'], (place) => {
                if (this.props.voting.configurations.filter === "rest") {
                    if (place.fields.Name === "Centre Monnet") {
                        disable = true;
                    }
                } else {
                    if (place.fields.Name !== "Centre Monnet") {
                        disable = true;
                    }
                }
            });

            if (disable) {
                return;
            }

            let column = data.fields[groupColumn[0]];
            if (groupColumn.length === 2) {
                if (Array.isArray(column) && column.length > 0) {
                    column = column[0].fields[groupColumn[1]];
                }
            }
            if (!column) {
                column = "Non déterminé";
            }
            if (!(column in groups)) {
                groups[column] = [];
            }

            groups[column].push(data);
        });

        const groupsSort = [];
        _.each(groups, (group, key) => {
            group.sort((a, b) => {
                if (a.fields[sortColumn] > b.fields[sortColumn]) {
                    return 1;
                }
                if (a.fields[sortColumn] < b.fields[sortColumn]) {
                    return -1;
                }
                return 0;
            });

            groupsSort.push({key, entries: group});
        });

        groupsSort.sort((a, b) => {
            if (a.key > b.key) {
                return 1;
            }
            if (a.key < b.key) {
                return -1;
            }
            return 0;
        });

        let first = groupsSort[0];

        this.setState({
            groups: groupsSort,
            active: first ? first.key : null
        })
    }

    render() {
        let record = null;
        if (this.state.active in this.records) {
            record = (<Record entry={this.records[this.state.active]}/>)
        }

        return (
            <Router>

                <Container fluid={true} style={{marginTop: '30px'}}>
                    <Route exact path="/" render={() => {
                        if (this.state.active !== null) {
                            return <Redirect to={/filters/ + this.state.active.replace("/","-")}/>
                        } else {
                            return null;
                        }
                    }}/>
                    <div className="MaintenantV2-Group-Filters">
                        {this.state.groups.map((group) => {
                            if (this.state.groups.length == 1) {
                                return null;
                            }
                            return (
                                <Route path={"/filters/" + group.key.replace("/", "-")}
                                       children={({match}) => (
                                           <Link to={"/filters/" + group.key.replace("/", "-")}>
                                               <GroupFilter key={group.key}
                                                            data={group}
                                                            active={match}
                                                            configuration={this.props.voting.configurations}
                                               />
                                           </Link>
                                       )}
                                />
                            );
                        })}
                    </div>

                    <Route path="/record/:id" render={(match) => {
                        if (match.match.params.id in this.records) {
                            return (<Record entry={this.records[match.match.params.id]} displayBackButton={this.state.groups.length === 1}/>)
                        }
                        return <div>Not Found</div>;
                    }}/>

                    {record}
                    {this.state.groups.map((group) => {
                        return (
                            <Route path={/filters/ + group.key.replace("/", "-")} render={() => {
                                return (
                                    <Group
                                        entries={group.entries}
                                        voting={this.props.voting}
                                        configuration={this.props.voting.configurations}
                                        format={this.props.voting.configurations.format}
                                        name={group.key}
                                        key={group.key}/>
                                );
                            }}/>
                        )
                    })}
                </Container>
            </Router>
        );
    }
}

export default MaintenantCardsV2;


// WEBPACK FOOTER //
// ./src/Components/MaintenantCardsV2.js